/*
 * @Description: 获取品牌列表
 * @Author: yy
 * @Date: 2019-05-31 14:47:29
 * @LastEditors: yy
 * @LastEditTime: 2019-09-04 16:35:34
 */

import React from 'react';

// @ts-ignore
import s from './BrandComplete.css';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { getBrandName } from '../../controller';

class BrandComplete extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      seaCompleteItem: [],
      isFixed: false,
      listIndex: 0,
      selectIndex: 0,
      mouseLeave: true,
      value: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.seaComplete = this.seaComplete.bind(this)
    this.mouseSlect = this.mouseSlect.bind(this)
    this.mouseOnClick = this.mouseOnClick.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)
    this.mouseEnter = this.mouseEnter.bind(this)
    this.isFocusFalse = this.isFocusFalse.bind(this)
    this.keyDown = this.keyDown.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value != this.props.value && nextProps.value != this.state.seaCompleteItem[0]) {
      this.seaComplete(nextProps.value)
    }
  }


  seaComplete = (e) => {
    const { value } = e.target
    this.setState({ value: value })
    if (value != '') {
      getBrandName({ q: value })
        .then(data => {
          const _data = typeof data === 'string' ? JSON.parse(data) : data
          this.setState({
            seaCompleteItem: _data.items,
          })
        })
        .catch(e => console.log("Oops, error", e))
    }
  }
  mouseEnter = () => {
    this.setState({ mouseLeave: false })
  }
  mouseLeave = () => {
    this.setState({ mouseLeave: true })
  }

  mouseSlect = (index) => {
    this.setState({ selectIndex: index })
  }

  mouseOnClick = () => {
    const { seaCompleteItem, selectIndex } = this.state
    const { isClearValue } = this.props
    this.props.getBrand(seaCompleteItem[selectIndex].name)
    this.setState({
      seaCompleteItem: [],
      value: isClearValue ? '' : seaCompleteItem[selectIndex].name
    })
  }

  isFocusFalse = () => {
    if (this.state.mouseLeave) {
      this.setState({
        seaCompleteItem: []
      })
    }
  }

  keyDown = (e) => {
    const { selectIndex, seaCompleteItem, value } = this.state
    const num = seaCompleteItem.length - 1

    if (e.key == 'ArrowUp' && seaCompleteItem.length != 0) {
      let cc = selectIndex < 1
        ? num
        : selectIndex - 1
      this.setState({ selectIndex: cc })
    } else if (e.key == 'ArrowDown' && seaCompleteItem.length != 0) {
      let cc = selectIndex < 1
        ? selectIndex + 1
        : selectIndex + 1
      this.setState({ selectIndex: cc })
    } else if (e.key == 'Backspace' && value.length == 1) {
      this.setState({ seaCompleteItem: [] })
    }
  }


  handleSubmit(e) {
    const { seaCompleteItem, selectIndex, value } = this.state
    const { isClearValue } = this.props
    e.preventDefault()
    if (seaCompleteItem[selectIndex]) {
      this.props.getBrand(seaCompleteItem[selectIndex].name)
      this.setState({
        seaCompleteItem: [],
        value: isClearValue ? '' : seaCompleteItem[selectIndex].name
      })

    } else {
      this.props.getBrand(value)
      this.setState({ value: isClearValue ? '' : value, seaCompleteItem: [] })
    }
  }

  render() {
    const { seaCompleteItem, selectIndex } = this.state
    const { inputClass } = this.props
    return (
      <div className={s.root} >

        <div className={s.cardInput}>
          <form onSubmit={this.handleSubmit}>
            <input
              className={s.input}
              onChange={this.seaComplete}
              value={this.state.value}
              type="text"
              placeholder="请输入品牌..."
              onKeyDown={this.keyDown}
              onBlur={this.isFocusFalse}
              style={inputClass}
            />
          </form>
          {seaCompleteItem.length == 0 ? null :
            <ul className={s.seaItems}
              onMouseLeave={this.mouseLeave}
              onMouseEnter={this.mouseEnter}
            >
              {seaCompleteItem
                .map((item, index) => (
                  <li key={index} className={selectIndex % seaCompleteItem.length == index ? cx(s.seaItem, s.seaAc) : s.seaItem}
                    onMouseEnter={() => this.mouseSlect(index)}
                    onClick={this.mouseOnClick}
                  >
                    <i><img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`} /></i>
                    {item.name}
                  </li>
                ))}
            </ul>
          }
        </div>
      </div>
    )
  }
}

export default withStyles(s)(BrandComplete);



// WEBPACK FOOTER //
// src/components/BrandComplete/BrandComplete.js